'use client'

import { DialogBackdrop } from '@headlessui/react'

interface BackdropProps {
  isOpen: boolean
  onClose?: () => void
  className?: string
  opacity?: 'light' | 'medium' | 'dark' | 'soft' | 'subtle'
}

const opacityVariants = {
  /** Page remains clearly visible; light dim only */
  subtle: 'bg-black/20 backdrop-blur-[2px]',
  soft: 'bg-black/30 backdrop-blur-[2px]',
  light: 'bg-black/50 backdrop-blur-sm',
  medium: 'bg-black/60 backdrop-blur-sm',
  dark: 'bg-black/90 backdrop-blur-sm',
}

export const Backdrop = ({
  isOpen,
  onClose,
  className = '',
  opacity = 'medium',
}: BackdropProps) => {
  if (!isOpen) return null

  return (
    <DialogBackdrop
      transition
      className={`
                fixed inset-0 ${opacityVariants[opacity]} 
                transition-opacity data-closed:opacity-0 
                data-enter:duration-300 data-leave:duration-200 
                data-enter:ease-out data-leave:ease-in
                ${className}
            `.trim()}
      onClick={onClose}
    />
  )
}
